document.addEventListener('DOMContentLoaded', function() {
  const modal = document.querySelector('.js-newsletter-modal');
  const forms = document.querySelectorAll('.js-newsletter-form');
  
  let feedbackTimeout;
  function showFeedback(successMsg, errorMsg, isSuccess, text) {
    if (feedbackTimeout) clearTimeout(feedbackTimeout);
    successMsg.style.display = 'none';
    errorMsg.style.display = 'none';
    
    const target = isSuccess ? successMsg : errorMsg;
    if (text) {
      target.textContent = text;
    }
    target.style.display = 'block';
    
    feedbackTimeout = setTimeout(function() {
      target.style.display = 'none';
    }, 2000);
  }

  if (!modal) {
    // Fallback: Bind submit event for forms if modal doesn't exist
    bindFormSubmits();
    return;
  }

  const trigger = modal.getAttribute('data-trigger') || 'delay';
  const delay = parseInt(modal.getAttribute('data-delay')) || 7;
  const scrollDepth = parseInt(modal.getAttribute('data-scroll')) || 50;

  // Check if popup was already dismissed in this session
  if (sessionStorage.getItem('newsletter-popup-dismissed')) {
    return;
  }

  // Bind close buttons
  const closeBtns = modal.querySelectorAll('.js-newsletter-modal-close');
  closeBtns.forEach(btn => {
    btn.addEventListener('click', closeModal);
  });

  bindFormSubmits(true);

  let lastFocusedElement = null;

  // Initialize selected trigger
  if (trigger === 'delay') {
    window.addEventListener('load', function() {
      setTimeout(openModal, delay * 1000);
    });
  } else if (trigger === 'scroll') {
    window.addEventListener('scroll', handleScrollTrigger);
  } else if (trigger === 'exit') {
    document.addEventListener('mouseleave', handleExitIntentTrigger);
  }

  function openModal() {
    if (sessionStorage.getItem('newsletter-popup-dismissed')) return;
    lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const focusTarget =
      modal.querySelector('.newsletter-popup__input') ||
      modal.querySelector('.js-newsletter-modal-close');
    if (focusTarget) focusTarget.focus();
  }

  function closeModal() {
    const active = document.activeElement;
    if (active instanceof HTMLElement && modal.contains(active)) {
      active.blur();
    }
    if (lastFocusedElement?.isConnected) {
      lastFocusedElement.focus();
    }

    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    sessionStorage.setItem('newsletter-popup-dismissed', 'true');
    
    // Clean up event listeners if closed
    window.removeEventListener('scroll', handleScrollTrigger);
    document.removeEventListener('mouseleave', handleExitIntentTrigger);
    document.removeEventListener('keydown', handleEscape);
  }

  function handleEscape(event) {
    if (event.key === 'Escape' && modal.style.display === 'flex') {
      closeModal();
    }
  }

  document.addEventListener('keydown', handleEscape);

  function handleScrollTrigger() {
    const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (totalHeight <= 0) return;
    
    const scrolled = (window.scrollY / totalHeight) * 100;
    if (scrolled >= scrollDepth) {
      openModal();
      window.removeEventListener('scroll', handleScrollTrigger);
    }
  }

  function handleExitIntentTrigger(e) {
    if (e.clientY < 20) {
      openModal();
      document.removeEventListener('mouseleave', handleExitIntentTrigger);
    }
  }

  function bindFormSubmits(isModal = false) {
    forms.forEach(form => {
      const emailInput = form.querySelector('input[type="email"]');
      const inputs = form.querySelectorAll('.newsletter-popup__input');
      inputs.forEach(input => {
        input.addEventListener('input', function() {
          if (!emailInput.value.trim()) {
            if (feedbackTimeout) clearTimeout(feedbackTimeout);
            form.querySelector('.js-newsletter-success').style.display = 'none';
            form.querySelector('.js-newsletter-error').style.display = 'none';
          }
        });
      });

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const firstNameInput = form.querySelector('input[name="first_name"]');
        const lastNameInput = form.querySelector('input[name="last_name"]');
        
        const successMessage = form.querySelector('.js-newsletter-success');
        const errorMessage = form.querySelector('.js-newsletter-error');

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailInput.value)) {
          showFeedback(successMessage, errorMessage, false, 'Please enter a valid email address.');
          return;
        }

        const listId = form.getAttribute('data-klaviyo-list-id');
        
        if (listId) {
          // Submit to Klaviyo AJAX API
          const data = new URLSearchParams();
          data.append('g', listId);
          data.append('email', emailInput.value);
          if (firstNameInput && firstNameInput.value) {
            data.append('$first_name', firstNameInput.value);
          }
          if (lastNameInput && lastNameInput.value) {
            data.append('$last_name', lastNameInput.value);
          }
          data.append('$fields', '$first_name,$last_name');

          fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: data
          })
          .then(response => {
            if (response.ok) {
              handleSuccess(successMessage, errorMessage, form, isModal);
            } else {
              throw new Error('Klaviyo subscription failed');
            }
          })
          .catch(error => {
            console.error(error);
            showFeedback(successMessage, errorMessage, false, 'Something went wrong. Please try again.');
          });
        } else {
          // Fallback for non-Klaviyo custom flow
          handleSuccess(successMessage, errorMessage, form, isModal);
        }
      });
    });
  }

  function handleSuccess(successMsg, errorMsg, form, isModal) {
    showFeedback(successMsg, errorMsg, true);
    form.reset();
    
    if (isModal) {
      setTimeout(closeModal, 1500);
    }
  }
});
